/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Trace_Step_ScentingInputs */

const vi_order_lot_trace_step_scenting = /** @type {(inputs: Order_Lot_Trace_Step_ScentingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô lấy hương`)
};

/**

* @param {Order_Lot_Trace_Step_ScentingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_step_scenting = /** @type {((inputs?: Order_Lot_Trace_Step_ScentingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_Step_ScentingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_step_scenting(inputs)
});